import { FixedSizeList, ListChildComponentProps } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import InfiniteLoader from "react-window-infinite-loader";

import { Loader } from '@shared/designSystem/Loader';
import styles from '@styles/components/General/VirtualizedList.module.css';


interface VirtualizedListProps<T> {
    itemCount: number;
    isItemLoaded: (index: number) => boolean;
    loadMoreItems?: (startIndex: number, stopIndex: number) => Promise<void>;
    renderRow: (index: number, style: React.CSSProperties) => JSX.Element;
    itemSize?: number;
    refInfiniteLoader?: React.Ref<InfiniteLoader>;
    pageSize?: number;
}


export function VirtualizedList<T>({
    refInfiniteLoader,
    pageSize,
    itemCount,
    isItemLoaded,
    loadMoreItems,
    renderRow,
    itemSize = 60,
  }: VirtualizedListProps<T>) {

    const Spinner = (({ style }) => (
        <div style={style} className={styles['loading-row']}>
            <Loader height="32px" width="32px" />
        </div>
    ));

    return (
      <AutoSizer>
        {({ height, width }) => (
          <InfiniteLoader
            ref={refInfiniteLoader}
            isItemLoaded={isItemLoaded}
            itemCount={itemCount}
            loadMoreItems={loadMoreItems ? loadMoreItems : () => Promise.resolve()}
            minimumBatchSize={pageSize}
            threshold={pageSize}
          >
            {({ onItemsRendered, ref }) => (
              <FixedSizeList
                height={height}
                width={width}
                itemCount={itemCount}
                itemSize={itemSize}
                onItemsRendered={onItemsRendered}
                ref={ref}
              >
                {({ index, style }: ListChildComponentProps) => {
                    if (!isItemLoaded(index)) {
                        return <Spinner style={style} />;
                      }
                      return renderRow(index, style)
                }}
              </FixedSizeList>
            )}
          </InfiniteLoader>
        )}
      </AutoSizer>
    );
  }
